<template>
  <footer class="footer">
    <div class="container-fluid">
      
      <div class="copyright pull-right">
        &copy; Coded with
        <i class="fa fa-heart heart"></i> by
        William Carneiro.
      </div>
    </div>
  </footer>
</template>
<script>
  export default {}

</script>
<style>

</style>
